import React from "react";

import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import Shimmer from "./Shimmer";
import s from "../Home/PopularLocationGridItem/PopularLocationGridItem.css";
import l from './Skeleton.css'

function HomePopularSkeleton() {

  return (
    <div className={cx(s.GridCollapse, 'GridCollapseAr')}>
      <div className={s.noPadding}>
        <div className={cx(l.parentBgColor, s.GridWrap)}>
          <Shimmer />
          <div className={cx(l.popularSkeletonCircle)}>
            <Shimmer />
          </div>
          <div className={cx(l.popularSkeletonContent)}>
            <Shimmer />
          </div>
        </div>
      </div>
    </div>

  );
}

export default withStyles(s, l)(HomePopularSkeleton);